import * as React from "react";
import {
  Layout,
  AppBar,
  TitlePortal,
  ToggleThemeButton,
  UserMenu,
  Logout,
  LoadingIndicator,
} from "react-admin";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { AppMenu } from "./AppMenu";
import { GlobalSearch } from "./GlobalSearch";

export const Logo = ({ compact }) => (
  <Box
    component="a"
    href="#/"
    sx={{ display: "flex", alignItems: "center", gap: 1.25, textDecoration: "none", color: "text.primary", flexShrink: 0 }}
  >
    <Box
      sx={{
        width: 32,
        height: 32,
        borderRadius: 2.5,
        display: "grid",
        placeItems: "center",
        background: "linear-gradient(135deg, #1B8550 0%, #0D5C33 100%)",
        color: "#fff",
        fontFamily: "Sora, sans-serif",
        fontWeight: 700,
        fontSize: 15,
        boxShadow: "0 2px 6px rgba(27,133,80,0.35)",
      }}
    >
      io
    </Box>
    {!compact && (
      <Typography sx={{ fontFamily: "Sora, sans-serif", fontWeight: 700, fontSize: 17, letterSpacing: "-0.01em" }}>
        ioUman <Box component="span" sx={{ color: "primary.main", fontWeight: 600 }}>Admin</Box>
      </Typography>
    )}
  </Box>
);

const AdminAppBar = () => {
  const small = useMediaQuery((t) => t.breakpoints.down("sm"));
  return (
    <AppBar
      color="inherit"
      toolbar={
        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
          <LoadingIndicator />
          <ToggleThemeButton />
        </Box>
      }
      userMenu={
        <UserMenu>
          <Logout />
        </UserMenu>
      }
      sx={{
        "& .RaAppBar-toolbar": { minHeight: 60, px: { xs: 1, sm: 2 } },
        "& .RaAppBar-menuButton": { color: "text.secondary", mr: 1 },
      }}
    >
      <Logo compact={small} />
      <Box sx={{ width: "1px", height: 22, bgcolor: "divider", mx: 2, flexShrink: 0, display: { xs: "none", sm: "block" } }} />
      <Box
        sx={{
          minWidth: 0,
          ml: { xs: 1, sm: 0 },
          flex: { xs: 1, md: "0 1 auto" },
          "& #react-admin-title": {
            fontFamily: "Sora, sans-serif",
            fontWeight: 600,
            fontSize: { xs: 14, sm: 15 },
            color: "text.secondary",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      >
        <TitlePortal variant="body1" />
      </Box>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <GlobalSearch compact={small} />
      </Box>
    </AppBar>
  );
};

export const AppLayout = ({ children }) => (
  <Layout menu={AppMenu} appBar={AdminAppBar}>
    {children}
  </Layout>
);

export default AppLayout;
